import styles from "./NavBar.module.css";
import FleekIcon from "../../asset/icons/FleekIcon.png"
import HumanIcon from "../../asset/icons/Human.png"
import React,{ useState ,useEffect }  from "react";
import { Link } from "react-router-dom";
import cx from 'classnames';
import { CoinPill } from "../../components/CoinPill/CoinPill";
import { MarketSwitcher } from "../../components/MarketSwitcher/MarketSwitcher";
import { isIndia } from "../../utils/market";
import  Api from "../../utils/Api/Api";
import { useAuthGate } from "../../components/AuthModal/AuthGate";


export const NavBar = ({hideNavOnMobile , fixedNavBar = true, image, isLoggedIn, landing = false})=>{
    const { requireAuth } = useAuthGate();
    const [userDetails,setUserDetails] = useState({
        avatar_url:''
    })
    const [avatarFailed, setAvatarFailed] = useState(false);

    useEffect(()=>{
        const fetchUserDetails = async ()=>{
            try {
                let { data: { avatar_url, name } = {} } = await Api.GetUserDetails();
     
                setUserDetails({
                    avatar_url: avatar_url || '',
                    name: name || ''
                })
            }
            catch(err) {
                // setError(true);
            }
            // setLoading(false)
        }
        if(isLoggedIn)
        fetchUserDetails();
    },[isLoggedIn])

    if(!image) {
        image = userDetails.avatar_url
    }
    // Signing in from the header has no pending action to resume. App.js reads
    // isLoggedIn from localStorage during render, so reload to refresh the
    // header, coin balance and any gated UI in one go.
    const openSignIn = () => requireAuth(
        () => window.location.reload(),
        'Sign in to your Fleek account.'
    );

    const NavBarStyle = ()=>{
        if(hideNavOnMobile){
            return cx(styles.NavBar , styles.hideOnMobile)
        }
        if(fixedNavBar){
            return cx(styles.NavBar , styles.fixedNavBar)
        }
        return styles.NavBar
    }
    return(
        <>
            <div className={styles.navContent}>
                <div className={NavBarStyle()}>
                    <Link className={styles.fleekTitleContainer} to={"/marketplace"}>
                        <img className={styles.fleekicon} src={FleekIcon} alt="FleekIcon" />
                        <p className={styles.fleektitle}>fleek</p>
                    </Link>
                    {landing && (
                        <nav className={styles.sectionNav}>
                            <a className={styles.sectionNavLink} href="#deals">Best prices</a>
                            <a className={styles.sectionNavLink} href="#categories">Categories</a>
                            <a className={styles.sectionNavLink} href="#brands">All brands</a>
                            <a className={styles.sectionNavLink} href="#bundles">Bundles</a>
                            <a className={styles.sectionNavLink} href="#how">How it works</a>
                        </nav>
                    )}
                    <div className={styles.rightContent}>
                        {/* The store chip ("🇬🇧 $"), once country stores are on. */}
                        <MarketSwitcher variant="chip" />
                        {/* Coins run in India; elsewhere the pill says they're coming. */}
                        <CoinPill comingSoon={!isIndia()} />
                        {!isLoggedIn && (
                            <button type="button" className={styles.signIn} onClick={openSignIn}>Sign in</button>
                        )}
                        {landing && (
                            <a className={styles.ctaButton} href="#deals">Start saving</a>
                        )}
                        <Link
                            style={{textDecoration: 'none'}}
                            to={isLoggedIn ? '/account' : '#'}
                            onClick={(e) => { if (!isLoggedIn) { e.preventDefault(); openSignIn(); } }}
                        >
                            <span className={styles.avatarCircle} aria-label={isLoggedIn ? "Account" : "Sign in"}>
                                {image && !avatarFailed ? (
                                    <img
                                        className={styles.avatarImg}
                                        src={image}
                                        alt=""
                                        onError={() => setAvatarFailed(true)}
                                    />
                                ) : isLoggedIn && userDetails.name ? (
                                    <span className={styles.avatarInitial}>{userDetails.name.trim().charAt(0).toUpperCase()}</span>
                                ) : (
                                    <img className={styles.icon} src={HumanIcon} alt="" />
                                )}
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
            {
                fixedNavBar && !hideNavOnMobile && <div className={styles.spacer}>

                </div>
            }
        </>
        
    )
}